import { render } from "./NotificationPerfectionReset.vue?vue&type=template&id=a9efcd0c&scoped=true"
import script from "./NotificationPerfectionReset.vue?vue&type=script&lang=js"
export * from "./NotificationPerfectionReset.vue?vue&type=script&lang=js"

import "@/css/components/notification-perfection-reset.css?vue&type=style&index=0&id=a9efcd0c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9efcd0c"]])

export default __exports__